import styled from "styled-components";

// h4인 태그 스타일 적용
export const H1Font = styled.h1`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 10px;
`;
